import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const mean: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	let count = 0;
	let sum = 0;

	// NOTE: If we ever support nested columns, we might want to average the `immediateChildRows` of
	// this grouping, since they'll have aggregated their own children.
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (!isComparableNumber(value)) {
			return;
		}

		const valueAsPositiveNumber = +value;
		count += 1;
		sum += +valueAsPositiveNumber;
	});

	if (count) {
		return round(sum / count);
	}
};
